import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { ActivatedRoute, Router } from "@angular/router";
import { Booked, Flight, Train } from "@models";
import { Store } from "@ngrx/store";
import { TranslateService } from "@ngx-translate/core";
import {
  AuthService,
  BookedService,
  BookService,
  CompanyService,
  ExcelService,
  MediaService,
  NgxToastrService,
  TravelService,
  UserService,
  UtilsService,
} from "@services";
import { DialogAssignProjectComponent } from "@shared/component/dialog-assign-project/dialog-assign-project.component";
import { PaginationConfig } from "@shared/interfaces";
import { MyBookedsState } from "app/store/reducers/my-bookeds.reducer";
import { forkJoin, of, Subject, Subscription } from "rxjs";
import { catchError, finalize, map, take, takeUntil } from "rxjs/operators";
import { AppState } from "../my-bookeds.reducer";
import { Location, PlatformLocation } from "@angular/common";
import { TravelContainerComponent } from './travel-container/travel-container.component';

@Component({
  selector: "app-user-my-bookeds",
  templateUrl: "./user-my-bookeds.component.html",
  styleUrls: ["./user-my-bookeds.component.scss"],
})
export class UserMyBookedsComponent implements OnInit, OnDestroy {
  paginationConf: PaginationConfig = {
    page: 1,
    pageSize: 9,
    collectionSize: 120,
  };
  companyImage = "";
  // FILTROS
  form: UntypedFormGroup;
  formTravel: UntypedFormGroup;
  statusOptions = [];
  bookeds: Booked[];
  flights: Flight[];
  trains: Train[];
  cars: any[];
  expenses;
  travels = [];
  isAdmin = false;
  user: any;
  requestBooked: boolean;
  request: boolean;
  canBook: boolean;
  userUuid = "";
  travelPagination = {};
  isLoadingTravel : boolean = false;
  @ViewChild(TravelContainerComponent)
  travelContainer?: TravelContainerComponent;
  travelSubscription: Subscription;
  companySubcription: Subscription;
  subcriptions: Subscription[] = [];
  loading = false;
  navActive = 1;
  module = "";
  isEmployee: boolean;
  companyUuid: string;
  isCompanyBookeds: boolean;
  all: any[] = [];
  isDownloading: boolean = false;
  travelsLoaded: boolean = false;

  showBookeds = true;
  showAuths = false;
  showRequests = false;
  departmentUuid: string;
  nextTravelsChecked = false;
  specialAction: string;
  routeSubscription: Subscription;
  fromReservation: boolean = false;
  travelTitlesLoaded: boolean = false;
  allCompanyUsers: any[];
  private destroy$ = new Subject<void>();
  private cancelBookingListener: any;
  private userCache = new Map<string, any>();
  reservations: any[] = [];

  reservationPage = 1;
  reservationPageSize = 5;
  reservationTotal = 0;

  reservationsPagination: any = {
    page: 1,
    pageSize: 5,
    collectionSize: 0,
  };
  private reservationsFeedCache = new Map<string, any>();

  constructor(
    private store: Store<AppState>,
    private bookedService: BookedService,
    private ngxToastrService: NgxToastrService,
    private formBuilder: UntypedFormBuilder,
    public translate: TranslateService,
    private userService: UserService,
    private travelService: TravelService,
    private route: ActivatedRoute,
    private mediaService: MediaService,
    private companyService: CompanyService,
    private router: Router,
    private excelService: ExcelService,
    private bookService: BookService,
    public utilsService: UtilsService,
    private dialog: MatDialog,
    private authService: AuthService,
    private _location: Location,
    private platformLocation: PlatformLocation
  ) {
    this.initForms();
    this.utilsService.allLoaded = false;
    this.paginationConf = {
      page: 1,
      pageSize: 9,
      collectionSize: 120,
    };
    this.isCompanyBookeds =
      this.route.snapshot.routeConfig.path === "bookings" ||
      this.route.snapshot.routeConfig.path === ":id/bookings";

    this.paginationConf.collectionSize = this.all.length;
    this.store
      .select("auth")
      .pipe(take(1))
      .subscribe((auth) => {
        this.isAdmin = auth.user
          ? auth.user?.type?.toUpperCase() !== "USER"
            ? true
            : false
          : this.authService.isAdmin();
        this.isEmployee = auth.user
          ? auth.user?.type?.toUpperCase() === "EMPLOYEE"
            ? true
            : false
          : this.authService.isEmployee();

        this.userUuid =
          (this.isAdmin || this.isEmployee) &&
          this.route.snapshot.paramMap.get("uuid")
            ? this.route.snapshot.paramMap.get("uuid")
            : auth.user?.uuid;
        if (!this.userUuid) {
          this.utilsService.getLocalStorageItem("userUuid");
        }
        this.companyUuid = this.route.snapshot.paramMap.has("id")
          ? this.route.snapshot.paramMap.get("id")
          : auth.user
          ? auth.user["companyUuid"]
          : null;
        this.utilsService.storeParamInLocalStorage({
          title: "userUuid",
          value: this.userUuid,
        });
        this.user = auth.user;
        if (!this.isEmployee && !this.isAdmin) {
          this.companyUuid = this.user?.companyUuid;
          this.userService
            .getPoliciesUser(this.userUuid)
            .pipe(take(1))
            .subscribe((policy) => {
              this.request = true;
              this.canBook =
                policy.filters.requestBooked ||
                policy.filters.requestTrain ||
                policy.filters.requestFlight;

              this.departmentUuid = this.user?.departmentUuid;
              this.loadData();
            });
        } else {
          if (this.userUuid != null && !this.isCompanyBookeds) {
            this.subcriptions.push(
              this.userService.getUser(this.userUuid).subscribe((user) => {
                this.companyUuid = user.companyUuid;
                this.departmentUuid = user.departmentUuid;
                this.loadData();
              })
            );
          } else {
              this.loadData();
          }
        }
      });

    const navigation = this.router.getCurrentNavigation();
    if (navigation?.extras.state) {
      this.fromReservation = navigation.extras.state.fromReservation || false;
    }
    this.module =
      this.router.getCurrentNavigation() &&
      this.router.getCurrentNavigation().extras &&
      this.router.getCurrentNavigation().extras.state
        ? this.router.getCurrentNavigation().extras.state.module
        : this.utilsService.getLocalStorageItem("module")
        ? this.utilsService.getLocalStorageItem("module").value
        : "Vyoo-All-Bookings";
    this.utilsService.storeParamInLocalStorage({
      title: "module",
      value: this.module,
    });
    if (this.module === "travels") {
      this.module = this.isAdmin ? "travels-admin" : "travels-user";
    }
    this.currentTab();
    if(this.user.accessType.toLowerCase() === "user"){
      this.bookService.clearCache();
    }

    this.cancelBookingListener = (result) => {
      this.loading = false;
      this.bookService.isLoading.next(false);
      const data = result?.data || {};
      const service = result?.service || data.service;
      const errorCancelKey =
        service === "train"
          ? "user.details.error-cancel-train"
          : "user.details.error-cancel-hotel";
      const successCancelKey =
        service === "train"
          ? "user.details.train-canceled"
          : "company.booked.booked-canceled";

      const isError =
        (data.type && (data.type.toLowerCase().includes("error") || data.type.toLowerCase().includes("exception"))) ||
        (data.bookingStatus && (data.bookingStatus.toLowerCase().includes('unknown') || data.bookingStatus.toLowerCase().includes('error')));

      if (isError) {
        if (data?.action === 410) {
          this.translate
            .get("user.details.error-cancel-provider")
            .subscribe((result0) => {
              this.ngxToastrService.typeInfo(null, result0);
            });
        } else if (data?.message) {
          this.ngxToastrService.typeInfo(null, data.message);
        } else {
          this.translate
            .get(errorCancelKey)
            .subscribe((result1) => {
              this.ngxToastrService.typeInfo(null, result1);
            });
        }
      } else {
        this.translate
          .get(successCancelKey)
          .subscribe((result2) => {
            this.ngxToastrService.typeSuccess(null, result2);
          });
          this.clearReservationsFeedCache();
          this.bookService.reload.next(true);
        }
    };

    this.utilsService.socket.on("cancel-booking", this.cancelBookingListener);
  }

  ngOnInit() {
    if(this.isCompanyBookeds){
      this.companyService.getCompanyUsers(this.companyUuid).subscribe(resp => {
        this.allCompanyUsers = resp.map(user => user.uuid);
      }, err => {})
    }
    this.routeSubscription = this.route.queryParams.subscribe(params => {
      if (params['specialAction']) {
        this.specialAction = params['specialAction'];
        this.router.navigate([], {
          relativeTo: this.route,
          queryParams: { },
          queryParamsHandling: 'merge',
        });
      }})
      if (this.fromReservation) {
        this.platformLocation.onPopState(() => {
          this.utilsService.setBackNavigation(true);
          this.router.navigate(['/flight']);
        });
      }
    this.statusOptions = [
      { value: "active", text: "common.confirmed" },
      { value: "cancelled", text: "common.canceled" },
    ];
    // this.loadRequest();

    this.store
      .select("myBookeds")
      .subscribe((myBookedsState: MyBookedsState) => {
        this.paginationConf.page = myBookedsState.paginationConfig.page;
      });

    this.bookService.reload.pipe(takeUntil(this.destroy$))
      .subscribe(() => {
        this.clearReservationsFeedCache();

        this.loading = true;
        this.utilsService.allLoaded = false;

        this.loadReservationsFeed(this.reservationPage, true);
      });
  }

  loadData() {
    this.loading = true;

    this.loadReservationsFeed(1);
    this.loadCompanyImg();
  }

  loadTravels() {
    this.isLoadingTravel = true;
    const params = {};
    if (!this.isCompanyBookeds) {
      params["userUuid"] = this.userUuid;
      params["companyUuid"] = this.companyUuid;
    } else {
      params["companyUuid"] = this.companyUuid;
    }
    this.travelSubscription = this.travelService
      .getTravelsWithParams(params)
      .subscribe(
        (travels: any) => {
          this.travels = travels.docs;
          this.travelsLoaded = true;
          this.travelPagination = travels;
          delete this.travelPagination["docs"];
          this.isLoadingTravel = false;
        },
        (err) => {
          this.isLoadingTravel = false;
          this.travelsLoaded = false;

          this.translate
            .get("my-bookeds.user.error-get-booked")
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(result, err.error.error);
            });
        }
      );
  }

  loadCompanyImg() {
    this.subcriptions.push(
      this.store.select("auth").subscribe((u) => {
        this.companySubcription = this.companyService
          .getCompanyImage(this.companyUuid, this.userUuid)
          .subscribe((img: string) => {
            this.mediaService.getMedia(img).subscribe((s) => {
              const reader = new FileReader();
              reader.readAsDataURL(s);
              let base64data;
              reader.onloadend = () => {
                base64data = reader.result;
                this.companyImage = base64data;
              };
            });
          });
      })
    );
  }

  addTravel() {
    const modalRef = this.dialog.open(DialogAssignProjectComponent, {
      data: {
        create: true,
        isOnlyCreate: true,
        userUuid: this.userUuid,
        companyUuid: this.companyUuid,
      },
      panelClass: "new-dialog",
    });
    modalRef.afterClosed().subscribe((result) => {
      if (result != null) {
        if (this.userUuid !== null) {
          result.travelData["userUuid"] = this.userUuid;
        }

        if (this.companyUuid !== null) {
          result.travelData["companyUuid"] = this.companyUuid;
        }
        if (
          result.travelData["endDate"] === "" &&
          result.travelData["initDate"] === ""
        ) {
          delete result.travelData["endDate"];
          delete result.travelData["initDate"];
        }
        this.subcriptions.push(
          this.travelService.postTravel(result.travelData).subscribe(
            () => {
              this.subcriptions.push(
                this.translate
                  .get(`project.my-projects.created`)
                  .subscribe((resp) => {
                    this.ngxToastrService.typeSuccess(null, resp);
                    setTimeout(() => {
                      if (this.nextTravelsChecked === false) {
                        this.travelContainer?.loadTravels(true);
                      }
                    }, 3000);
                  })
              );
            },
            (err) => {
              this.subcriptions.push(
                this.translate.get("common.error").subscribe((resp) => {
                  this.ngxToastrService.typeInfo(resp, err.error.message);
                })
              );
            }
          )
        );
      }
    });
  }

  currentTab() {
    switch (this.module) {
      case "all":
        this.navActive = 1;
        break;
      case "hotels":
        this.navActive = 2;
        break;
      case "flights":
        this.navActive = 3;
        break;
      case "trains":
        this.navActive = 4;
        break;
      case "cars":
        this.navActive = 5;
        break;
      case "expenses":
        this.navActive = 6;
        break;
      case "travels-user":
        this.navActive = 7;
        break;
      case "travels-admin":
        this.navActive = 8;
        break;
      default:
        this.utilsService.bookeds = this.utilsService.sortArrayByDate(this.all);
        break;
    }
  }

  exportExcel(service: string) {
    this.isDownloading = true;

    if (service === "travel") {
      const travelParams: any = {};

      if (this.isCompanyBookeds) {
        travelParams.companyUuid =
          this.companyUuid;
      } else {
        travelParams.userUuid =
          this.userUuid;

        travelParams.companyUuid =
          this.companyUuid;
      }

      this.subcriptions.push(
        this.travelService
          .getTravelsWithParams(travelParams)
          .pipe(
            take(1),
            finalize(() => {
              this.isDownloading = false;
            })
          )
          .subscribe({
            next: (response: any) => {
              const travels =
                response?.docs || [];

              this.excelService.createProjectsExcel(
                "Vyoo-Project Report",
                travels,
                this.isAdmin &&
                  this.isCompanyBookeds,
                this.userUuid
              );
            },
            error: (err) => {
              this.translate
                .get(
                  "my-bookeds.user.error-get-booked"
                )
                .pipe(take(1))
                .subscribe((message) => {
                  this.ngxToastrService.typeInfo(
                    message,
                    err?.error?.error ||
                      err?.error?.message ||
                      err?.message
                  );
                });
            },
          })
      );

      return;
    }

    const params = this.buildReservationsExportParams(service);

    this.subcriptions.push(
      this.bookedService.getReservationsFeed(params).pipe(take(1)).subscribe(
        (response: any) => {
          const reservations = response.docs || [];
          const grouped = this.groupReservationsForExcel(reservations);
          const excelPayload = this.getExcelPayloadByService(service, grouped);

          const hotelUuids = this.collectUuids(
            excelPayload.bookings || [],
            excelPayload.customBookings || []
          );

          const fileName = this.getExcelFileName(service);

          if (!hotelUuids.length) {
            this.excelService.createBookingsExcel(fileName, excelPayload);
            this.isDownloading = false;
            return;
          }

          this.subcriptions.push(
            this.fetchUsersByUuids(hotelUuids).pipe(take(1)).subscribe(
              ({ users, usersByUuid }) => {
                excelPayload.users = users;
                excelPayload.usersByUuid = usersByUuid;

                this.excelService.createBookingsExcel(fileName, excelPayload);
                this.isDownloading = false;
              },
              () => {
                this.excelService.createBookingsExcel(fileName, excelPayload);
                this.isDownloading = false;
              }
            )
          );
        },
        (err) => {
          this.isDownloading = false;
          this.translate
            .get("my-bookeds.user.error-get-booked")
            .subscribe((result) => {
              this.ngxToastrService.typeInfo(
                result,
                err.error?.error || err.error?.message || err.message
              );
            });
        }
      )
    );
  }

  private getExcelFileName(service: string): string {
    switch (service) {
      case "hotel":
        return "Vyoo-Hotel Report";
      case "flight":
        return "Vyoo-Flight Report";
      case "train":
        return "Vyoo-Train Report";
      case "car":
        return "Vyoo-Car Report";
      case "expense":
        return "Vyoo-Expense Report";
      case "all":
      default:
        return this.module ? this.module : "Vyoo-Bookings";
    }
  }

  changeComponent(event) {
    switch (event.value) {
      case "authorization":
        this.showBookeds = false;
        this.showAuths = true;
        this.showRequests = false;
        break;

      case "request":
        this.showBookeds = false;
        this.showAuths = false;
        this.showRequests = true;
        break;

      case "booking":
      case "booked":
        this.showBookeds = true;
        this.showAuths = false;
        this.showRequests = false;

        if (!this.reservations || this.reservations.length === 0) {
          this.loadReservationsFeed(this.reservationPage || 1);
        }

        break;

      default:
        this.showBookeds = true;
        this.showAuths = false;
        this.showRequests = false;
        break;
    }
  }

  reloadType(event?: any) {
    this.clearReservationsFeedCache();
    this.loadReservationsFeed(this.reservationPage, true);
  }

  loadTravelTitles(afterLoad?: () => void) {
    const params = {
      companyUuid: this.companyUuid,
      userUuids: this.allCompanyUsers ? this.allCompanyUsers : [this.userUuid],
    };

    this.travelService.getTravelsByListBooking(params).subscribe(
      (response: any) => {
        this.assignTitlesToReservations(response);

        this.travelTitlesLoaded = true;
        this.loading = false;

        if (afterLoad) {
          afterLoad();
        }
      },
      () => {
        this.travelTitlesLoaded = true;
        this.loading = false;

        if (afterLoad) {
          afterLoad();
        }
      }
    );
  }

  assignTitlesToReservations(projectTitleByUuidWrapper: any) {
    const projectTitleByUuid = projectTitleByUuidWrapper.projectTitleByUuid || {};

    const assign = (items: any[] = []) => {
      items.forEach((item) => {
        const travelTitle = projectTitleByUuid[item.uuid];

        if (travelTitle) {
          item.travelTitle = travelTitle;
        }
      });
    };

    assign(this.reservations);
    assign(this.bookeds || []);
    assign(this.flights || []);
    assign(this.cars || []);
    assign(this.expenses || []);
    assign(this.trains || []);
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
    if (this.cancelBookingListener) {
      this.utilsService.socket.off("cancel-booking", this.cancelBookingListener);
    }
    if (this.routeSubscription) {
      this.routeSubscription.unsubscribe();
    }
    if (this.travelSubscription) {
      this.travelSubscription.unsubscribe();
    }
    if (this.subcriptions) {
      this.subcriptions.forEach((sub) => {
        sub.unsubscribe();
      });
    }
    this.utilsService.removeItemFromLocalStorage("module");
    this.utilsService.userBookingsFilters.fromDate = null;
    this.utilsService.userBookingsFilters.toDate = null;
    this.utilsService.userBookingsFilters.createdFromDate = null;
    this.utilsService.userBookingsFilters.createdToDate = null;
    this.bookService.clearCache();
  }

  onSelectChangeToGrandparent(selectedValue) {
    this.nextTravelsChecked = selectedValue.checked;
  }

  private collectUuids(...lists: any[][]): string[] {
    const set = new Set<string>();

    const arrays = (lists || []).filter(a => Array.isArray(a));

    for (let i = 0; i < arrays.length; i++) {
      const arr = arrays[i] || [];
      for (let j = 0; j < arr.length; j++) {
        const item = arr[j];
        const raw = item && item.userUuid;
        const ids: string[] = Array.isArray(raw) ? raw : (raw ? [raw] : []);
        for (let k = 0; k < ids.length; k++) {
          const id = ids[k];
          if (id) set.add(id);
        }
      }
    }
    return Array.from(set);
  }

  private fetchUsersByUuids(uuids: string[]) {
    const missing = uuids.filter(id => !this.userCache.has(id));
    const requests = missing.map(id =>
      this.userService.getUserByUuid(id).pipe(
        take(1),
        catchError(() => of(null)),
        map(user => ({ id, user }))
      )
    );

    return (requests.length ? forkJoin(requests) : of([])).pipe(
      map((pairs: Array<{ id: string; user: any }>) => {
        for (let i = 0; i < pairs.length; i++) {
          const p = pairs[i];
          if (p && p.user) this.userCache.set(p.id, p.user);
        }

        const usersByUuid: { [uuid: string]: any } = {};
        this.userCache.forEach((val, key) => {
          usersByUuid[key] = val;
        });

        const users: any[] = [];
        for (const key in usersByUuid) {
          if (Object.prototype.hasOwnProperty.call(usersByUuid, key)) {
            users.push(usersByUuid[key]);
          }
        }

        return { users, usersByUuid };
      })
    );
  }

  getReservationTypeFromTab(): string {
    switch (this.navActive) {
      case 2:
        return "hotel";
      case 3:
        return "flight";
      case 4:
        return "train";
      case 5:
        return "car";
      case 6:
        return "expense";
      default:
        return "all";
    }
  }

  loadReservationsFeed(page: number = 1, forceRefresh: boolean = false) {
    const params = this.buildReservationsFeedParams(page);
    const cacheKey = this.getReservationsFeedCacheKey(params);

    const cachedResponse = this.reservationsFeedCache.get(cacheKey);

    if (cachedResponse && !forceRefresh) {
      this.applyReservationsFeedResponse(
        this.cloneReservationResponse(cachedResponse),
        page
      );

      this.travelTitlesLoaded = true;
      this.loading = false;
      this.showBookeds = true;
      this.utilsService.allLoaded = true;

      return;
    }

    this.loading = true;
    this.showBookeds = false;
    this.utilsService.allLoaded = false;
    this.travelTitlesLoaded = false;

    this.bookedService.getReservationsFeed(params).subscribe({
      next: (res) => {
        this.applyReservationsFeedResponse(res, page);

        this.travelTitlesLoaded = true;
        this.loading = false;
        this.showBookeds = true;
        this.utilsService.allLoaded = true;

        const responseToCache = {
          ...res,
          docs: this.reservations,
          page: this.reservationPage,
          totalDocs: this.reservationTotal,
        };

        this.reservationsFeedCache.set(
          cacheKey,
          this.cloneReservationResponse(responseToCache)
        );
      },
      error: (err) => {
        this.showBookeds = true;
        this.loading = false;
        this.utilsService.allLoaded = true;
        this.travelTitlesLoaded = true;

        this.translate
          .get("my-bookeds.user.error-get-booked")
          .subscribe((result) => {
            this.ngxToastrService.typeInfo(
              result,
              err.error?.error || err.error?.message || err.message
            );
          });
      },
    });
  }

  onReservationTabChange(tabId: number) {
    this.navActive = tabId;

    if (tabId >= 1 && tabId <= 6) {
      this.loadReservationsFeed(1);
    }
  }

  private initForms() {
    this.form = this.formBuilder.group({
      modelHotel: "",
      modelDestiny: "",
      statusOptions: "active",
    });

    this.formTravel = this.formBuilder.group({
      title: "",
      total: 0,
    });
  }

  private buildReservationsFeedParams(page: number = 1): any {
    const params: any = {
      page,
      pageSize: this.reservationPageSize,
      type: this.getReservationTypeFromTab(),
    };

    const status = this.form?.value?.statusOptions;

    if (status && status !== "all") {
      params.status = status;
    }

    if (this.form?.value?.modelHotel) {
      params.search = this.form.value.modelHotel;
    }

    if (this.userUuid && !this.isCompanyBookeds) {
      params.userUuid = this.userUuid;
    }

    if (this.companyUuid) {
      params.companyUuid = this.companyUuid;
    }

    const filters = this.utilsService.userBookingsFilters;

    if (filters.fromDate) {
      params.fromDate = filters.fromDate;
    }

    if (filters.toDate) {
      params.toDate = filters.toDate;
    }

    if (filters.createdFromDate) {
      params.createdFromDate = filters.createdFromDate;
    }

    if (filters.createdToDate) {
      params.createdToDate = filters.createdToDate;
    }

    if (this.nextTravelsChecked) {
      params.onlyUpcoming = true;
    }

    return params;
  }

  private getReservationsFeedCacheKey(params: any): string {
    const sortedParams = Object.keys(params)
      .sort()
      .reduce((acc, key) => {
        acc[key] = params[key];
        return acc;
      }, {});

    return JSON.stringify(sortedParams);
  }

  private cloneReservationResponse(response: any): any {
    return JSON.parse(JSON.stringify(response));
  }

  private clearReservationsFeedCache(): void {
    this.reservationsFeedCache.clear();
  }

  private applyReservationsFeedResponse(res: any, page: number): void {
    this.reservations = res.docs || [];

    this.reservationPage = res.page || page;
    this.reservationTotal = res.totalDocs || 0;

    this.reservationsPagination = {
      page: this.reservationPage,
      pageSize: this.reservationPageSize,
      collectionSize: this.reservationTotal,
    };

    this.all = this.reservations;

    this.bookeds = this.reservations.filter(
      (x) =>
        x.serviceType === "hotel" ||
        x.serviceType === "booking" ||
        x.serviceType === "customBooking" ||
        x.serviceType === "airbnb"
    );

    this.flights = this.reservations.filter((x) => x.serviceType === "flight");
    this.trains = this.reservations.filter((x) => x.serviceType === "train");
    this.cars = this.reservations.filter((x) => x.serviceType === "car");
    this.expenses = this.reservations.filter((x) => x.serviceType === "expense");

    this.showBookeds = true;
    this.utilsService.allLoaded = true;
  }

  private buildReservationsExportParams(service: string): any {
    const params = this.buildReservationsFeedParams(1);

    params.type = service === "hotel" ? "hotel" : service;
    params.export = true;

    delete params.page;
    delete params.pageSize;

    return params;
  }

  private groupReservationsForExcel(reservations: any[]) {
    const grouped = {
      bookings: [],
      customBookings: [],
      flights: [],
      trains: [],
      cars: [],
      expenses: [],
    };

    (reservations || []).forEach((reservation) => {
      if (
        reservation.bookingSource === "booked" ||
        reservation.serviceType === "hotel" ||
        reservation.serviceType === "booking"
      ) {
        grouped.bookings.push(reservation);
        return;
      }

      if (
        reservation.bookingSource === "customBooking" ||
        reservation.serviceType === "customBooking" ||
        reservation.serviceType === "airbnb"
      ) {
        grouped.customBookings.push(reservation);
        return;
      }

      if (reservation.serviceType === "flight") {
        grouped.flights.push(reservation);
        return;
      }

      if (reservation.serviceType === "train") {
        grouped.trains.push(reservation);
        return;
      }

      if (reservation.serviceType === "car") {
        grouped.cars.push(reservation);
        return;
      }

      if (reservation.serviceType === "expense") {
        grouped.expenses.push(reservation);
      }
    });

    return grouped;
  }

  private getExcelPayloadByService(service: string, grouped: any) {
    switch (service) {
      case "hotel":
        return {
          bookings: [
            ...(grouped.bookings || []),
            ...(grouped.customBookings || []),
          ],
        };

      case "flight":
        return {
          flights: grouped.flights || [],
        };

      case "train":
        return {
          trains: grouped.trains || [],
        };

      case "car":
        return {
          cars: grouped.cars || [],
        };

      case "expense":
        return {
          expenses: grouped.expenses || [],
        };

      case "all":
      default:
        return grouped;
    }
  }

  onNextBookingsFilterChange(value: boolean) {
    this.nextTravelsChecked = value;
    this.reservationPage = 1;

    this.clearReservationsFeedCache();
    this.loadReservationsFeed(1, true);
  }

  goBack() {
    this._location.back();
  }
}
